import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './IconRight.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface IconRightProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconRight: FC<IconRightProps> = (props) => {
  const { className, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <svg
        width='16'
        height='11'
        viewBox='0 0 16 11'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M9 0.5L15 5.49998L9 10.5' stroke='currentColor' strokeMiterlimit='10' />
        <path d='M0 5.5H15' stroke='currentColor' />
      </svg>
    </div>
  );
};

export default memo(IconRight);
